import routes from './routes';
import { RouterProvider } from 'react-router-dom';


const App = () => {
    return  <RouterProvider router = {routes}></RouterProvider>
};

export default App;